import { Input, Directive } from '@angular/core';

import { ControlContainer, ControlValueAccessor } from '@angular/forms';

import { BaseControl } from './base-control';

/**
 * Basic control model extended from all shared components,
 * which are created as form controls
 */
@Directive()
export abstract class BaseControlComponent<ValueType, ChangeValueAttributeType, FormsControlType> implements ControlValueAccessor {
  protected readonly countryIconClassPrefix: string;

  protected value: ValueType | ValueType[] | undefined;
  protected onChange: ((value: ValueType) => void) | undefined;

  public onTouched: (() => void) | undefined;

  @Input() public control: BaseControl<ValueType> | undefined;
  @Input() public formControlName: string;
  @Input() public controlPlaceHolder: string | undefined;

  protected constructor(protected controlContainer: ControlContainer) {
    this.countryIconClassPrefix = 'flag flag-';

    // @ts-ignore
    if (!this.formControlName) {
      this.formControlName = '';
    }
  }

  protected checkInvalid(): void {
    if (this.controlContainer && this.controlContainer.control && this.control) {
      const control = this.controlContainer.control.get(this.control.name);

      this.control.invalid = Boolean(control && control.invalid);
    }
  }

  abstract asFormsControl(): FormsControlType;

  abstract changeValue(attribute: ChangeValueAttributeType): void;

  /**
   * ControlValueAccessor methods
   */

  /**
   * @param value
   *
   * Write value from model or form control
   * to the DOM element.
   */
  writeValue(value: ValueType | ValueType[]): void {
    if (typeof value !== 'undefined') {
      this.value = value;

      if (this.control && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
        this.control.value = value;
      }
    }
  }

  /**
   * @param fn
   *
   * Register custom on change event handler.
   */

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  /**
   * @param fn
   *
   * Register custom on blur(touched) event handler.
   */
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  /** **************************** */
}
